// extracted by mini-css-extract-plugin
export default {"alert-button":"styles_alert-button__Kp1t0"};